import React, { useRef } from "react";
import { Typography, Button, Tooltip, message } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined, DeleteOutlined, PlusOutlined, ToolOutlined } from "@ant-design/icons";
import api from "src/config/api";
import {
  FormDatePicker,
  FormText,
  FormSelect,
} from "src/components/Form";
import eventBus from "src/common/eventBus";
import Table from "src/components/Table/Table";
import { formatDate } from "src/shared/dateTimeUtils";

const Bikes = () => {
  const navigate = useNavigate();
  const tableRef = useRef();
  const actions = [
    <Button
      icon={<PlusOutlined />}
      onClick={() => navigate("new")}
      type="primary"
    >
      Add
    </Button>,
  ];

  const filterInputs = [
    <FormText name="bikeName" placeholder="Bike Name" allowClear />,
    <FormText name="licenseNumber" placeholder="License Number" allowClear />,
    <FormText name="owner" placeholder="Owner" allowClear />,
    <FormSelect
      name="status"
      placeholder="Status"
      allowClear
      options={[
        { label: "In Stock", value: "IN" },
        { label: "Rented Out", value: "OUT" },
      ]}
    />,
  ];

  const columns = [
    {
      dataIndex: "bikeName",
      title: "Bike",
      width: "180px",
      defaultSortOrder: "ascend",
      render: (bikeName, row) => (
        <div>
          {bikeName}
          {row.licenseNumber && ` (${row.licenseNumber})`}
        </div>
      ),
    },
    {
      dataIndex: "status",
      title: "Status",
      width: "100px",
      render: (status) => {
        const statusText = status === 'OUT' ? 'Rented Out' : 'In Stock';
        const color = status === 'OUT' ? '#ff4d4f' : '#52c41a';
        return (
          <span style={{ 
            color: 'white', 
            backgroundColor: color, 
            padding: '3px 10px', 
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '500',
            display: 'inline-block',
            textAlign: 'center'
          }}>
            {statusText}
          </span>
        );
      },
    },
    {
      title: "Current Rental",
      width: "200px",
      render: (_, row) => {
        if (row.status !== 'OUT' || !row.customerName) {
          return <span style={{ color: '#999' }}>Not rented</span>;
        }
        
        return (
          <div style={{ fontSize: "0.9em" }}>
            <div><strong>{row.customerName}</strong></div>
            <div>{row.customerPhone}</div>
            <div>Out: {formatDate(row.dateOut)}</div>
            <div>Return: {formatDate(row.dateReturn)}</div>
          </div>
        );
      },
    },
    {
      title: "Financial",
      width: "200px",
      render: (_, row) => (
        <div style={{ fontSize: "0.9em" }}>
          <div>Purchase: {formatCurrency(row.purchasePrice)}</div>
          <div>Profit: {formatCurrency(row.profit)}</div>
          <div>In: {formatCurrency(row.moneyIn)}</div>
          <div>Out: {formatCurrency(row.moneyOut)}</div>
        </div>
      ),
    },
    {
      title: "Maintenance",
      width: "120px",
      render: (_, row) => (
        <div style={{ fontSize: "0.9em" }}>
          <div>Last Oil Change: {formatDate(row.lastOilChange)}</div>
          {row.kilometersRun && (
            <div>KM: {row.kilometersRun}</div>
          )}
        </div>
      ),
    },
    {
      dataIndex: "actions",
      title: "Actions",
      width: "160px",
      render: (_, row) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => navigate(`/bikes/${row.id}`)}
            />
          </Tooltip>
          <Tooltip title="Expenses">
            <Button
              icon={<ToolOutlined />}
              onClick={() => navigate(`/bikes/${row.id}/expenses`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              danger
              onClick={() => {
                eventBus.emit("dialog", {
                  type: "confirm",
                  message: `Are you sure to delete bike ${row.bikeName}?`,
                  onOk: async () => {
                    await api.delete(`bikes/${row.id}`);
                  },
                  onFinish: () => {
                    tableRef.current.refresh();
                  },
                });
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Helper function to format currency in Vietnamese style
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '';
    return `${Number(amount).toLocaleString('vi-VN')} VND`;
  };

  return (
    <>
      <Typography.Title level={4} className="mb-4">
        Bikes
      </Typography.Title>
      <Table
        ref={tableRef}
        url={"bikes"}
        actions={actions}
        filterInputs={filterInputs}
        columns={columns}
      ></Table>
    </>
  );
};

export default Bikes; 